export default {
  status: {
    open: "Offen",
    in_progress: "In Bearbeitung",
    waiting_response: "Antwort ausstehend",
    resolved: "Gelöst",
    closed: "Geschlossen",
  },
  priority: {
    "1": "Kritisch",
    "2": "Hoch",
    "3": "Mittel",
    "4": "Niedrig",
    "5": "Unwesentlich",
  },
  category: {
    problem: "Problem",
    suggestion: "Vorschlag",
    improvement: "Verbesserung",
    question: "Frage",
    billing: "Abrechnung",
  },
} as const;
